// extracted by mini-css-extract-plugin
export default {"premium":"styles_premium__MBleC","container":"styles_container__cPEc2","frequently":"styles_frequently__JJtc-"};